import { action, debug, CardAPI } from "aaa";
import { CardAPIClient } from "network/APIClient";
import { AccountsStore } from "stores/AccountsStore";
import { CardStore } from "stores/CardStore";
import { ISigningInfo } from "types/signing";

export class QuickDrawdownStore {
    accountsStore = new AccountsStore();
    cardStore = new CardStore();
    transferResponse?: { signInfo: ISigningInfo };
    amount = 0;
    badRequestMessage?: string;

    isLoading(): boolean {
        return this.accountsStore.isLoading
            || (this.cardStore !== undefined && this.cardStore.isLoading)
            ;
    }

    @action async load(cardId: string) {
        await Promise.all([
            this.cardStore.loadCard(cardId),
            this.accountsStore.load()
        ]);

        if (this.cardStore.card && this.cardStore.card.directDebitAccount) {
            this.accountsStore.selectAccountByIban(this.cardStore.card.directDebitAccount.iban, true);
        } else {
            throw new Error("no card or no linked direct debit account");
        }
    }

    async transfer() {
        const card = this.cardStore!.card!;
        const target = CardAPI.putTransfer(card.id, this.amount, card.directDebitAccount!.iban);
        this.transferResponse = await CardAPIClient.requestJSON(target) as any;
        debug.log("### transfer", this.transferResponse);
    }
}


// WEBPACK FOOTER //
// ./src/components/quickDrawdown/QuickDrawdownStore.tsx